<template>
    <div class="page-content">
        <SketchBreadcrumb pageName="Notificări"></SketchBreadcrumb>
        <div class="padding-box">
            <div class="white-box">
                <div class="title-div">
                    <h3>Notificări</h3>
                </div>
                <div v-if="notifications && notifications.length > 0" class="notifications-box">
                    <div v-for="(notification, key) in notifications" :key="key" class="ticket-content">
                        <div class="ticket-reply" :class="{'ticket-agent' : !notification.is_read}">
                            <div class="head">
                                <div class="head-flex">
<!--                                    <img src="">-->
                                    <div>
                                        <p class="mb-0 bold-text">{{ notification.title }}</p>
                                    </div>
                                </div>
                                <p>{{ formatUtcDate(notification.created_at, 'DD.MM.YYYY (HH:mm)') }} - {{ notification.time_ago }}</p>
                            </div>
                            <div class="body">
                                <div v-html="notification.message"></div>
                            </div>
                            <div v-if="notification.link" class="footer">
                                <p>Link:</p>
                                <a :href="notification.link" target="_blank" class="text-purple-dark font-medium">{{ notification.link }}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <p style="font-size: 16px; text-align: center; font-weight: 600">Momentan, nu există notificări.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import {formatUtcDate} from '@/helpers/helpers'
    export default {
        components: {
            SketchBreadcrumb
        },
        data() {
            return {
            }
        },
        computed: {
            notifications() {
                return this.$store.getters['notifications/notifications'];
            }
        },
        mounted() {
            this.$store.dispatch('pageLoading/setLoading', false)
            this.$store.dispatch('notifications/setAllRead')
        },
        methods: {
            formatUtcDate,
        }
    }
</script>

<style scoped>
.title-div{
    margin-bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
}
.white-box{
    height: auto;
    min-height: 100%;
}
.title-div h3{
    font-size: 25px;
    color:#aa93a8;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.ticket-content{
    margin-top: 15px;
}
.ticket-content .head-flex{
    display: flex;
    align-items: center;
}
.ticket-content .head-flex img{
    margin-right: 15px;
    border-radius: 50%;
    max-width: 30px;
}
.ticket-reply .body{
    font-size: 14px;
}
.ticket-reply .body >>> img{
    width: 100%;
    max-width: 850px;
}
.ticket-reply{
    margin-bottom: 15px;
}
.ticket-agent .body{
    border: 1px solid #8c6984 !important;
}
.ticket-agent .footer{
    background: #8c6984 !important;
}
.ticket-reply .footer{
    background: #6c757d;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 6px 20px;
    margin-top: -4px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.ticket-reply .footer p, .ticket-reply .footer a{
    font-size: 12px;
    color: #fff;
}
.ticket-reply .footer a{
    font-weight: 600;
    margin: 0 5px;
    text-decoration: none;
}
.ticket-agent .head{
    background: #8c6984 !important;
}
.ticket-reply .head{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    background: #6c757d;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding: 6px 20px;
}
.ticket-reply .head p{
    color: #fff;
}
.bold-text{
    font-weight: 600;
}
.ticket-reply .body{
    padding: 15px 20px;
    border: 1px solid #cdd2d7;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}
</style>
